import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { LogService, ScreenResolution } from 'htv-lib'

@Injectable({
  providedIn: 'root',
})
export class ResolutionService {
  isLoading$ = new BehaviorSubject<boolean>(true)
  resolutionChanged$ = new BehaviorSubject<ScreenResolution>(ScreenResolution.RES_1080P)
  readonly defaultResolution: ScreenResolution = ScreenResolution.RES_1080P

  private _currentResolution: ScreenResolution = this.defaultResolution

  constructor(private logService: LogService) {
    // do nothing
  }

  init(initialResolution?: string | ScreenResolution): void {
    this.logService.info(`[ResolutionService] - Initialization`)

    const resolution = initialResolution ? initialResolution : this.defaultResolution
    this.setResolution(resolution)

    this.isLoading$.next(false)
  }

  setResolution(resolution: any): void {
    let validResolution = this.defaultResolution

    if (
      resolution === ScreenResolution.RES_720P ||
      resolution === ScreenResolution.RES_1080P ||
      resolution === ScreenResolution.RES_4K
    ) {
      validResolution = resolution
    } else {
      this.logService.info(`[ResolutionService] Invalid resolution: ${resolution}. Using default.`)
    }

    this.logService.info(`[ResolutionService] Setting resolution to: ${validResolution}`)
    this._currentResolution = validResolution
    this.resolutionChanged$.next(validResolution)
  }

  getCurrentResolution(): ScreenResolution {
    return this._currentResolution
  }
}
